<template lang="pug">
div.w-full
  h3.text-sm.font-semibold.mb-3 Service Details
  .grid.grid-cols-2.gap-4
    //- Service ID
    div(v-if="data.id !== undefined")
      p.text-xs.text-muted-foreground.mb-1 Service ID
      p.text-sm.font-mono \#{{ data.id }}
    
    //- User
    div(v-if="data.user_id")
      p.text-xs.text-muted-foreground.mb-1 User
      NuxtLink(:to="`/dashboard/${data.user_id}`" class="text-sm text-blue-600 hover:underline inline-flex items-center gap-1")
        | User \#{{ data.user_id }}
        Icon(name="lucide:external-link" class="w-3 h-3")
    
    //- Type
    div(v-if="data.cate")
      p.text-xs.text-muted-foreground.mb-1 Type
      p.text-sm.font-medium.capitalize {{ data.cate }}
    
    //- Status
    div(v-if="data.status")
      p.text-xs.text-muted-foreground.mb-1 Status
      p.text-sm.font-medium(:class="data.status === 'on' ? 'text-green-600' : 'text-red-600'")
        | {{ data.status === 'on' ? 'Active' : 'Inactive' }}
    
    //- Traffic
    div(v-if="data.used !== undefined || data.quote !== undefined")
      p.text-xs.text-muted-foreground.mb-1 Traffic
      p.text-sm
        | {{ $utils.trFormat(data.used || 0) }} / 
        span(v-if="data.quote > 0") {{ $utils.trFormat(data.quote) }}
        span(v-else) Unlimited
    
    //- Premium Traffic
    div(v-if="data.cate === 'allplatform' && (data.pre_used !== undefined || data.pre_quota !== undefined)")
      p.text-xs.text-muted-foreground.mb-1 Relay Data
      p.text-sm {{ $utils.trFormat(data.pre_used || 0) }} / {{ $utils.trFormat(data.pre_quota || 0) }}
    
    //- Port
    div(v-if="data.port")
      p.text-xs.text-muted-foreground.mb-1 Port
      p.text-sm.font-mono {{ data.port }}
    
    //- Shadow Ban
    div(v-if="data.extra?.shadow_ban")
      p.text-xs.text-muted-foreground.mb-1 Shadow Ban
      p.text-sm.text-orange-600.font-medium Yes
    
    //- Device Limit
    div(v-if="data.extra?.device_limit")
      p.text-xs.text-muted-foreground.mb-1 Device Limit
      p.text-sm {{ data.extra.device_limit }}
    
    //- Duration
    div(v-if="data.extra?.buy_length")
      p.text-xs.text-muted-foreground.mb-1 Duration
      p.text-sm {{ data.extra.buy_length }} months
    
    //- Created
    div(v-if="data.created_at")
      p.text-xs.text-muted-foreground.mb-1 Created
      p.text-sm {{ $utils.dateStr(data.created_at) }}
    
    //- Updated
    div(v-if="data.updated_at")
      p.text-xs.text-muted-foreground.mb-1 Updated
      p.text-sm {{ $utils.dateStr(data.updated_at) }}
  
  //- Raw JSON (collapsible)
  details.mt-6
    summary.cursor-pointer.text-xs.text-muted-foreground(class="hover:text-foreground") View Raw JSON
    pre.mt-2.p-3.text-xs.font-mono.whitespace-pre.border.rounded {{ jsonString }}
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: any
}>()

const $utils = useUtils()

const jsonString = computed(() => JSON.stringify(props.data, null, 2))
</script>
